module.exports = __webpack_public_path__ + "static/pohjalainenyrittaja2-140x140-5875.96bd4649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pohjalainenyrittaja2-140x140-5875.jpg
// module id = 837
// module chunks = 129563053867776